<template>
  <f7-page class="no-swipeback" login-screen @page:reinit id="login" >
    <a href="#main-content" class="skip-link">
      {{ $t('accessibility.skip_to_main_content') || 'Aller au contenu principal' }}
    </a>
    <div class="body bgLogin">
      <b-row class="h-100">
        <div class="loginPanel loginHeight">
          <div>
            <b-row class="panel-heading ajust text-center mb-2rem">
              <b-col cols="2"></b-col>
              <b-col cols="8" class="p-2">
                <span class="navbar-brand mr-0 w-80">
                  <img :src="imgVarsLong" alt="DealPrudence" class="heritage largescreen w-100">
                  <!--<img :src="imgVarsShort" @click="loadAccueil" alt="VOP" class="heritage middlescreen">-->
                </span>
              </b-col>
              <b-col cols="2" class="p-0">
                <b-dropdown left class="no-back" toggle-class="border-0 m-md-2 z-5" variant="light" v-model="language">
                  <template slot="button-content">
                    <img class="flag-nav d-none-min-1460px" :src="language === 'FR' ? logoFlagFR : logoFlagEN" alt="FR"/>
                    <img class="flag-nav d-none-max-1459px" :src="language === 'FR' ? logoFlagFR : logoFlagEN" alt=""/><span class="d-none-max-1459px mr-1">{{ labelLanguage }}</span>
                  </template>
                  <b-dropdown-item v-for="option in langOptions" :key="option.value" class="dropdown-item-web-header" @click="languageCountry(option.value)">
                    <img class="flag-nav" v-if="option.value === 'FR'" :src="logoFlagFR" alt=""/>
                    <img class="flag-nav" v-else :src="logoFlagEN" alt=""/>
                    <span>{{option.text}}</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-col>
            </b-row>
            <div @keyup.enter="registerUser()" v-if="mode === 'confirmEmail'">
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <form-write-group-label-input v-model="credentials.Login" id="Login"
                    inputType="text"
                    :inputLabel="$t('common.eml_adrs')"
                    inputClass="inputLogin"
                    :specificErrorIndicator="credentials.LoginError"
                    :specificMessage="credentials.LoginErrorMessage">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <form-write-group-label-input v-model="credentials.Token" id="Token"
                    inputType="text"
                    :inputLabel="$t('common.login_token')"
                    inputClass="inputLogin"
                    :specificErrorIndicator="credentials.TokenError"
                    :specificMessage="credentials.TokenErrorMessage">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
            </div>
            <div @keyup.enter="registerUser()" v-if="mode === 'register'">
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <form-write-group-label-input v-model="credentials.Login" id="Login"
                    inputType="text"
                    :inputLabel="$t('common.eml_adrs')"
                    inputClass="inputLogin"
                    :specificErrorIndicator="credentials.LoginError"
                    :specificMessage="credentials.LoginErrorMessage">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <!-- Password -->
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <div>
                    <label for="password">{{ $t('common.pwd') }}</label>
                    <div class="d-flex">
                      <input v-model="credentials.Password"
                        id="password"
                        class="form-control inputAccordionForm inputLogin h-30px"
                        :class="[credentials.PasswordError ? 'errorBorder' : '']"
                        :type="credentials.PasswordFieldType">
                      </input>
                      <i class="icon icon-password mt-2 pt-1"
                        :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                        @click="togglePasswordVisibility">
                      </i>
                    </div>
                    <div v-if="credentials.PasswordError" class="text-danger">
                      {{ credentials.PasswordErrorMessage }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <!-- Password Confirmation -->
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <div>
                    <label for="password">{{ $t('common.pwd') }}</label>
                    <div class="d-flex">
                      <input v-model="credentials.PasswordRepeat"
                        id="password"
                        class="form-control inputAccordionForm inputLogin h-30px"
                        :class="[credentials.PasswordRepeatError ? 'errorBorder' : '']"
                        :type="credentials.PasswordRepeatFieldType">
                      </input>
                      <i class="icon icon-password mt-2 pt-1"
                        :class="[isPasswordRepeatFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                        @click="togglePasswordRepeatVisibility">
                      </i>
                    </div>
                    <div v-if="credentials.PasswordRepeatError" class="text-danger">
                      {{ credentials.PasswordRepeatErrorMessage }}
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div v-else-if="mode === 'confirmEmailSent'">
              <span>{{$t('loginPage.email_confirmation_mail_sent')}}</span>
            </div>

            <b-row class="loginButtons" v-if="['confirmEmail', 'register'].includes(mode)">
              <b-col cols="8" offset="2">
                <b-button variant="primary" size="lg" id="submit-btn"
                  @click="registerUser()">
                  {{ $t('loginPage.create_account') }}
                </b-button>
              </b-col>
            </b-row>
            <div class="pt-3 pb-1">
              <b-row>
                <b-col class="xs-12 text-center">
                  <b-col class="d-flex justify-content-center align-items-center">
                    <img class="logoStreammind" alt="Streammind" :src="logoStreammind"></img>
                    <span> {{ $t('common.copyright')}}</span>&nbsp;
                    <span>{{ version }}</span>
                  </b-col>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </b-row>
    </div>
  </f7-page>
</template>

<script>

import conf from '../../config/config.dev.js'

import _ from 'lodash'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import Spinner from '@/components/common/spinner'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage, loadPageClearHistory} from '@/helpers/routing'

import design from '@/design/design.json'
import StreammindImage from '@/assets/static/images/streammind-text-seul.png'
import FlagFRImage from './../../assets/static/images/fr.png'
import FlagENImage from './../../assets/static/images/gb.png'

export default {
  name: 'RegisterWithToken',
  props: {
    // marche pas en route, on les récup dans l'URL du coup
    // token: {
    //   type: String,
    //   default: ''
    // },
    // email: {
    //   type: String,
    //   default: '-1'
    // }
  },
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput,
    'spinner': Spinner
  },
  computed: {
    labelLanguage () {
      let lang = this.language
      let langOpt = this.langOptions.filter(elem => elem.value.toLowerCase() === lang.toLowerCase())
      let label = this.$t('lang.french')
      if (langOpt.length) {
        label = langOpt[0].value
      }
      return label
    },
    imgVarsLong () {
      return this.design.headbandLogoLong
    },
    isPasswordFieldHidden () {
      return this.credentials.PasswordFieldType === 'password'
    },
    isPasswordRepeatFieldHidden () {
      return this.credentials.PasswordRepeatFieldType === 'password'
    }
  },
  data: () => {
    return {
      design: design.login,
      confirmEmail: '',
      credentials: {
        Login: '',
        LoginError: false,
        LoginErrorMessage: '',
        Token: '',
        TokenError: false,
        TokenErrorMessage: '',
        Password: '',
        PasswordError: false,
        PasswordErrorMessage: '',
        PasswordFieldType: 'password',
        PasswordRepeat: '',
        PasswordRepeatError: false,
        PasswordRepeatErrorMessage: '',
        PasswordRepeatFieldType: 'password'
      },
      email: '-1',
      flagTOOLBOX: conf.visual === 'TOOLBOX',
      idAccount: '',
      langOptions: [],
      language: '',
      logoFlagFR: FlagFRImage,
      logoFlagEN: FlagENImage,
      logoStreammind: StreammindImage,
      mode: '',
      token: '',
      version:''
    }
  },
  created () {
    this.language = this.$i18n.locale.toUpperCase()
    this.langOptions = [
      { value: 'FR', text: this.$t('lang.french')},
      { value: 'EN', text: this.$t('lang.english')}
    ]
    let route = this.$f7.mainView.url.split('/')
    if (route.length >= 4) {
      this.token = route[2]
      this.email = route[3]
    }
    if (this.email !== '-1' && this.token) {
      this.mode = 'register'
      this.credentials.Token = this.token
      this.credentials.Login = this.email
    } else {
      this.mode = 'confirmEmail'
    }
  },
  mounted () {
    if (this.$engine.firstOn().auth.user.get().identifier !== '' && !location.href.includes('OTP')) {
      this.$$('.navbar').removeClass('deleteNavBar')
      this.$bus.$emit('login', true)
      loadPageClearHistory(this, {url: this.flagTOOLBOX ? '/homecarrousel/' : '/home/'})
    }
  },
  methods: {
    languageCountry (language) {
      this.language = language
      if (language === 'EN') {
        this.$i18n.locale = 'en'
      } else {
        this.$i18n.locale = 'fr'
      }
      this.langOptions = [
        { value: 'FR', text: this.$t('lang.french')},
        { value: 'EN', text: this.$t('lang.english')}
      ]
    },
    togglePasswordRepeatVisibility () {
      this.credentials.PasswordRepeatFieldType = (this.credentials.PasswordRepeatFieldType === 'text' ? 'password' : 'text')
    },
    togglePasswordVisibility () {
      this.credentials.PasswordFieldType = (this.credentials.PasswordFieldType === 'text' ? 'password' : 'text')
      this.credentials = _.cloneDeep(this.credentials)
    },
    validateForm () {
      let result = true
      if (!this.credentials.Login) {
        this.credentials.LoginError = true
        this.credentials.LoginErrorMessage = this.$i18n.t('errors.eml_adrs_mandatory')
        result = false
      } else if (!(/^.+@.+\..+$/.test(this.credentials.Login)) && this.credentials.Login.length < 50) {
        this.credentials.LoginError = true
        this.credentials.LoginErrorMessage = this.$i18n.t('errors.eml_adrs_format')
        result = false
      } else {
        this.credentials.LoginError = false
        this.credentials.LoginErrorMessage = ''
      }
      if (this.mode === 'confirmEmail') {
        // control token
        if (!this.credentials.Token) {
          result = false
          this.credentials.TokenError = true
          this.credentials.TokenErrorMessage = this.$i18n.t('errors.token_mandatory')
        } else {
          this.credentials.TokenError = false
          this.credentials.TokenErrorMessage = ''
        }
      } else if (this.mode === 'register') {
        // control password et confirmPassword
        if (!this.credentials.Password) {
          result = false
          this.credentials.PasswordError = true
          this.credentials.PasswordErrorMessage = this.$i18n.t('errors.password_wrong_format')
        }
        // on ne check pas le format pour le moment
        // else if (!this.credentials.Password) {
          // result = false
          // this.credentials.PasswordError = true
          // this.credentials.PasswordErrorMessage = this.$i18n.t('errors.password_mandatory')
        // }
        else {
          this.credentials.PasswordError = false
          this.credentials.PasswordErrorMessage = ''
        }

        if (!this.credentials.PasswordRepeat) {
          result = false
          this.credentials.PasswordRepeatError = true
          this.credentials.PasswordRepeatErrorMessage = this.$i18n.t('errors.password_repeat_mandatory')
        }
        else if (this.credentials.PasswordRepeat !== this.credentials.Password) {
          result = false
          this.credentials.PasswordRepeatError = true
          this.credentials.PasswordRepeatErrorMessage = this.$i18n.t('errors.passwords_not_matching')
        } else {
          this.credentials.PasswordRepeatError = false
          this.credentials.PasswordRepeatErrorMessage = ''
        }
      }
      return result
    },
    registerUser () {
      if (!this.validateForm()) {
        return
      }

      let that = this
      if (this.mode === 'confirmEmail') {
        this.$engine.firstOn().auth.registerToken({
          email: this.credentials.Login,
          token: this.credentials.Token,
          lang: that.language
        })
        .then(resp => {
          that.mode = 'confirmEmailSent'
        })
        .catch(error => {
          let errMsgTitle = ''
          let errMsgDesc = ''
          if (error && error.response && error.response.data && error.response.data.error) {
            if (('errors._specific.title.' + error.response.data.error) !== that.$t('errors._specific.title.' + error.response.data.error)) {
              errMsgTitle = that.$t('errors._specific.title.' + error.response.data.error)
              errMsgDesc = that.$t('errors._specific.description.' + error.response.data.error)
            }
          }
          if (errMsgTitle && errMsgDesc) {
            that.$f7.alert(errMsgDesc, errMsgTitle)
          } else {
            errorMessageAlert(error, that)
          }
        })
      } else if (this.mode === 'register') {
        this.$engine.firstOn().auth.registerToken({
          email: this.credentials.Login,
          password: this.credentials.Password,
          token: this.credentials.Token,
          lang: that.language
        })
        .then(resp => {
          that.$f7.showPreloader(this.$t('registerPage.rgstrtn_done'))
          that.$engine.firstOn().auth.login({
            ConnectBy: 'lpc',
            WithPassword: '1',
            Login: that.credentials.Login,
            Password: that.credentials.Password
          })
          .then(resp => {
            that.$engine.firstOn().user.connectBy = 'login-password-capi'
            that.$bus.emit('login', true)
            that.$bus.emit('service:change', this.defaultService)
            that.$bus.emit('refresh-cache-menu')
            that.$f7.hidePreloader()
            that.$$('.panel-overlay').css('z-index', '')
            that.$$('.deleteNavBar').removeClass('deleteNavBar')
            loadPageClearHistory(that, {url: that.flagTOOLBOX ? '/homecarrousel/' : '/home/'})
          })
          .catch(err => {
            that.$f7.hidePreloader()
            errorMessageAlert(err, that)
          })
        })
        .catch(error => {
          that.$f7.hidePreloader()
          let errMsgTitle = ''
          let errMsgDesc = ''
          if (error && error.response && error.response.data && error.response.data.error) {
            if (('errors._specific.title.' + error.response.data.error) !== that.$t('errors._specific.title.' + error.response.data.error)) {
              errMsgTitle = that.$t('errors._specific.title.' + error.response.data.error)
              errMsgDesc = that.$t('errors._specific.description.' + error.response.data.error)
            }
          }
          if (errMsgTitle && errMsgDesc) {
            that.$f7.alert(errMsgDesc, errMsgTitle)
          } else {
            errorMessageAlert(error, that)
          }
        })
      }
    }
  }
}
</script>
